import type { PreEnrollmentValidationError } from "@repo/models";
import type { GridList } from "@repo/ui";

import type { User } from "../models/User";
import type { PreEnrollmentValidationFilter } from "../pages/preEnrollmentValidation/types";

import { BaseController } from "./baseController";
import { BaseGridApi } from "./baseGridApi";

export const controller = "PreEnrollmentValidation";
const gridFiltersController = "GridFilters";

export default class PreEnrollmentValidationApi {
	static Get = BaseController.GetFn(controller);
	static Post = BaseController.PostFn(controller);
	static GetGridFilters = BaseController.GetFn(gridFiltersController);

	static getValidations(filter: PreEnrollmentValidationFilter) {
		return PreEnrollmentValidationApi.Get<GridList<PreEnrollmentValidationError>>("GetValidations", filter);
	}

	static getTypes() {
		return PreEnrollmentValidationApi.Get<{ Id: number; Name: string }[]>("GetTypes");
	}

	static getUsers() {
		return PreEnrollmentValidationApi.GetGridFilters<User[]>("GetUsers", { adminsOnly: true });
	}

	static loadGridSettings() {
		return BaseGridApi.loadGridSettings(controller, "Pre Validations");
	}

	static saveGridSettings(settingsJson: string) {
		return BaseGridApi.saveGridSettings(controller, "Pre Validations", settingsJson);
	}

	static getGridColumns() {
		return BaseGridApi.getGridColumns<any>(controller, "PreEnrollmentValidation");
	}
}
